import { useState } from "react";

//used in all form pages
export function useFormFields(initialState) {
  const [fields, setValues] = useState(initialState);

  //takes intial values and returns fields, with sets values using hooks
  return [
    fields,
    function (fieldName, value) {
      if (fieldName === null && typeof value === "object") {
        setValues(value);
      } 
      else {
        setValues({
          ...fields,
          [fieldName]: value,
        });
      }
    },
  ];
}
